var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentModule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 38.5C77 59.763 59.763 77 38.5 77C17.237 77 0 59.763 0 38.5C0 17.237 17.237 0 38.5 0C59.763 0 77 17.237 77 38.5Z",
    fill: "#FDC5C5",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9091 24C60.0639 24 61 25.2641 61 26.8235V45.1765C61 46.7359 60.0639 48 58.9091 48H40.0909C38.9361 48 38 46.7359 38 45.1765V26.8235C38 25.2641 38.9361 24 40.0909 24H58.9091ZM44.2725 26.8238H40.0908V31.0585H44.2725V26.8238ZM46.3634 31.0585V26.8238H58.909V31.0585H46.3634ZM44.2725 33.882H40.0908V38.1177H44.2725V33.882ZM46.3634 38.1177V33.882H58.909V38.1177H46.3634ZM44.2725 40.9412H40.0908V45.1768H44.2725V40.9412ZM46.3634 45.1768V40.9412H58.909V45.1768H46.3634Z",
    fill: "#CF2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37.7143C17.5383 37.7143 19.0135 37.1122 20.1012 36.0406C21.1889 34.969 21.8 33.5155 21.8 32M39.2 52C39.2 50.4845 39.8111 49.031 40.8988 47.9594C41.9865 46.8878 43.4617 46.2857 45 46.2857M16 34.8571C16 34.0994 16.3055 33.3727 16.8494 32.8368C17.3932 32.301 18.1309 32 18.9 32H42.1C42.8691 32 43.6068 32.301 44.1506 32.8368C44.6945 33.3727 45 34.0994 45 34.8571V49.1429C45 49.9006 44.6945 50.6273 44.1506 51.1632C43.6068 51.699 42.8691 52 42.1 52H18.9C18.1309 52 17.3932 51.699 16.8494 51.1632C16.3055 50.6273 16 49.9006 16 49.1429V34.8571ZM34.8493 42C34.8493 44.3669 32.9017 46.2857 30.4993 46.2857C28.0968 46.2857 26.1493 44.3669 26.1493 42C26.1493 39.6331 28.0968 37.7143 30.4993 37.7143C32.9017 37.7143 34.8493 39.6331 34.8493 42Z",
    stroke: "#CF2A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentModule);
export default __webpack_public_path__ + "static/media/PaymentModule.7a982a7883fe14ed7dd7b2b0f792dce3.svg";
export { ForwardRef as ReactComponent };